/*
 * Built with Common Launchpad 2.0.3
 */

export const EnvironmentUrl = window.Launchpad.ApiBaseUrl;
export const globalProject = window.Launchpad;

export const ViewPort = {
	Desktop: 'desktop',
	Tablet: 'tablet',
	Mobile: 'mobile'
};

export const Breakpoints = {
	Desktop: '970',
	Tablet: '750'
};